
import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import AppHelper from '@/AppHelper'
import { LoginService } from '@/types/streaming_services'
import { CampaignPatch } from '@/types/campaigns'
import { Campaign } from '@/Campaign'

interface ServiceToggle {
  value: LoginService
  label: string
  icon: string
}

// Sign in with Apple is a login method, not a streaming service, so it
// isn't part of the app's streaming_services config. Offer it here too —
// the Music tab is where login services are enabled for now.
const APPLE_ID_TOGGLE: ServiceToggle = {
  value: 'apple_id',
  label: 'Sign in with Apple',
  icon: 'mdi-apple'
}

@Component
export default class MusicServices extends Vue {
  @Getter('apps/currentHelper') app!: AppHelper
  @Getter('campaigns/current') campaign!: Campaign
  @Getter('campaigns/editLoading') loading!: boolean
  @Action('campaigns/EDIT_CURRENT') saveCampaign!: (data: CampaignPatch) => Promise<void>

  keyIncr = 0 // Incrementing key cause toggles need re-rendering. v-switch keeps some internal state nonsense

  get services (): ServiceToggle[] {
    const appServices: ServiceToggle[] = this.app.streamingServiceNames.map(
      service => ({ value: service, label: service, icon: `mdi-${service}` })
    )
    return [...appServices, APPLE_ID_TOGGLE]
  }

  get enabledServices (): LoginService[] {
    return this.campaign.data.enabled_services
  }

  async toggleService (service: LoginService) {
    let newServices = [...this.enabledServices]
    if (newServices.includes(service)) {
      newServices = newServices.filter(s => s !== service)
    } else {
      newServices.push(service)
    }

    try {
      await this.saveCampaign({ enabled_services: newServices })
    } finally {
      this.keyIncr++
    }
  }
}
